/// <reference path='../_all.ts' />


module navigation {
   'use strict';

   export class PageMetaService implements IPageMetaService {

      // $inject annotation.
      // It provides $injector with information about dependencies to be injected into constructor
      // it is better to have it close to the constructor, because the parameters must match in count and type.
      // See http://docs.angularjs.org/guide/di
      public static $inject = [
         '$rootScope',
         'anchorNavService',
      ];

      constructor(
         private $rootScope: IPageMetaRootScope
         , private anchorNavService: navigation.IAnchorNavService
      ) {

         anchorNavService.subscribeOnLocationChanged(null, () => {
            this.updateTitleDescription();
         });
         this.updateTitleDescription();


      };

      getPageMeta(key?: string): IPhotometerGlobalVar | string | any {
         if (!key) return pglob;
         if (key === 'hl') return pglob.RouteData.CurrentLanguage.hl;  
         if (key === 'hlFull') return pglob.RouteData.CurrentLanguage.hlFull;
         if (key === 'hlPrefix') return pglob.RouteData.CurrentLanguage.hlPrefix;
         if (key === 'current' && pglob.RouteData.RouteEntry.RouteParameterStack.length > 0) return pglob.RouteData.RouteEntry.RouteParameterStack[0];
         if (key === 'parent' && pglob.RouteData.RouteEntry.RouteParameterStack.length > 1) return pglob.RouteData.RouteEntry.RouteParameterStack[1];
         if (key === 'username' && pglob.RouteData.User) return pglob.RouteData.User;
         if (key === 'email' && pglob.RouteData.Email) return pglob.RouteData.Email;
         if (key === 'PageId' && pglob.RouteData.PageId) return pglob.RouteData.PageId;
         return null;
      };


      getContentFilterFor(key: string, useRouteParameter?: boolean, category?: number): editor.EditorFilter {
         if (useRouteParameter === void 0) { useRouteParameter = true; }
         if (category === void 0) { category = 9; }

         var f: editor.EditorFilter = new editor.EditorFilter();
         var rpv: IRouteParameter[] = pglob.RouteData.RouteEntry.RouteParameterStack;

         f.Category = 12;

         if (useRouteParameter) {
           if (rpv.length == 1) {
              if (rpv[0].Placeholder !== "Child") f.Filter1 = rpv[0].Id;
           }

           if (rpv.length == 2) {
              if (rpv[1].Placeholder !== "Child") f.Filter1 = rpv[1].Id;
              if (rpv[0].Placeholder !== "Child") f.Filter2 = rpv[0].Id;
           }

           if (rpv.length == 3) {
              if (rpv[2].Placeholder !== "Child") f.Filter1 = rpv[2].Id;
              if (rpv[1].Placeholder !== "Child") f.Filter2 = rpv[1].Id;
              if (rpv[0].Placeholder !== "Child") f.Filter3 = rpv[0].Id;
           }
         }

         f.FilterString1 = pglob.RouteData.PageId;
         f.FilterString2 = key;
         f.Category = category;
         f.rpv = pglob.RouteData.RouteEntry.RouteParameterStack;
         f.IsLanguageIndifferent = false;

         return f;
      }

      updateTitleDescription() {
         if (pglob.RouteData.RouteEntry.RouteParameterStack.length < 1) return;

         //use basepage
         var index = 0;
         while (pglob.RouteData.RouteEntry.RouteParameterStack.length > index && pglob.RouteData.RouteEntry.RouteParameterStack[index].PageId != pglob.RouteData.BasePageId) index++;
         if (index == pglob.RouteData.RouteEntry.RouteParameterStack.length) index = 0;

         if (!pglob.RouteData.RouteEntry.RouteParameterStack[index].PageTitle
            || !pglob.RouteData.RouteEntry.RouteParameterStack[index].MetaDescription) index = 0;

         if (pglob.RouteData.RouteEntry.RouteParameterStack[index].PageTitle) {
            var pageTitle = pglob.RouteData.RouteEntry.RouteParameterStack[index].PageTitle[pglob.RouteData.CurrentLanguage.hlFull];
            this.$rootScope.pageTitle = pageTitle;
         }

         if (pglob.RouteData.RouteEntry.RouteParameterStack[index].MetaDescription) {
            var metaDescription = pglob.RouteData.RouteEntry.RouteParameterStack[index].MetaDescription[pglob.RouteData.CurrentLanguage.hlFull];
            this.$rootScope.metaDescription = metaDescription;
         }

      }

      searchRouteParameter(placeholder: string): IRouteParameter {
         var routeParameter: IRouteParameter[] = pglob.RouteData.RouteEntry.RouteParameterStack.filter((param: IRouteParameter, i: number): boolean => {
            return param.Placeholder === placeholder;
         });

         if (routeParameter.length > 0) return routeParameter[0];
         return null;
      }

      searchNode(placeholder: string, id: number, nodes: MenuNode[]) : MenuNode {
         //search current level
         var found = nodes.filter((n, i, a) => {
            return n.RouteEntry.RouteParameterStack.length > 0 && 
                     n.RouteEntry.RouteParameterStack[0].Placeholder == placeholder &&
                     n.RouteEntry.RouteParameterStack[0].Id == id;
         })
         if (found.length > 0) return found[0];

         //search depth first
         var child = null;
         nodes.some((n, i, a) => {
            if (n.Nodes && n.Nodes.length > 0) {
               return child = this.searchNode(placeholder, id, n.Nodes);               
            }
         });
         if (child) return child;
      }

      searchPage(placeholder: string, id: number): angular.IPromise<MenuNode> {
         return this.anchorNavService.getNavigationData().then((nd: MenuNode[]) => {
            var found = this.searchNode(placeholder, id, nd);
            if (found) return found;
         });

         //var routeParameter :IRouteParameter[] = pglob.RouteData.RouteEntry.RouteParameterStack.filter((param : IRouteParameter, i: number) : boolean => {
         //  return param.Placeholder === placeholder;
         //});

         //if (routeParameter.length > 0) return routeParameter[0];
         //return null;
      }

   }
}